<div class="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
  @for (toast of uiStore.toasts(); track toast.id) {
    <div @toastFade
      class="flex items-center gap-3 rounded-xl px-4 py-3 shadow-xl text-sm text-white min-w-[300px]"
      [class.bg-success-400]="toast.type === 'success'"
      [class.bg-danger-400]="toast.type === 'error'"
      [class.bg-primary-500]="toast.type === 'info'">
      @switch (toast.type) {
        @case ('success') { <app-icon name="check-circle" size="md" /> }
        @case ('error') { <app-icon name="exclamation-triangle" size="md" /> }
        @case ('info') { <app-icon name="information-circle" size="md" /> }
      }
      <span class="flex-1">{{ toast.text }}</span>
      <button (click)="uiStore.dismissToast(toast.id)" class="text-white/80 hover:text-white">&times;</button>
    </div>
  }
</div>
